export const productcard =[
   {
      id :1,
      Details:"Men Casual Shirt.",
      Qty:"10",
      Price:"$4523",
      Status:" Done",
      badgeClass: 'success'
   },
   {
      id :2,
      Details:"Rayon Women Regular Top.",
      Qty:"20",
      Price:"$2523",
      Status:"Pending",
      badgeClass: 'warning'
   },
   {
      id :3,
      Details:"Flower Printed Dress",
      Qty:"40",
      Price:"$2623",
      Status:"Done",
      badgeClass: 'success'
   },
   {
      id :4,
      Details:"Polyester Women Dress",
      Qty:"05",
      Price:"$5623",
      Status:"In process",
      badgeClass: 'info'
   },
   {
      id :5,
      Details:"Cotton Regular T-Shirt",
      Qty:"08",
      Price:"$9545",
      Status:"Pending",
      badgeClass: 'warning'
   },
   {
      id :6,
      Details:"Printed Sleeve Dress",
      Qty:"12",
      Price:"$1543",
      Status:"Pending",
      badgeClass: 'warning'
   }
]
